import { Badge, Flex } from '@radix-ui/themes';
import { TbTrendingUp, TbSparkles, TbPlant, TbBug } from 'react-icons/tb';
import Styles from '../css/releases-modal.module.scss';

export function getReleaseType(type: string) {
  switch (type) {
    case 'feature':
      return (
        <Badge color="cyan" radius="full" variant="soft" size="2">
          Feature
        </Badge>
      );
    case 'improvement':
      return (
        <Badge color="green" radius="full" variant="soft" size="2">
          Improvement
        </Badge>
      );
    case 'bug':
      return (
        <Badge color="yellow" radius="full" variant="soft" size="2">
          Bug
        </Badge>
      );
    default:
      return (
        <Badge color="cyan" radius="full" variant="soft" size="2">
          Update
        </Badge>
      );
  }
}

export function getReleaseTypeIcon(type: string) {
  switch (type) {
    case 'feature':
      return (
        <Flex justify="center" align="center" className={Styles.ReleasesPopUpSparkles} data-type="feature">
          <TbPlant fontSize="2rem" color="var(--cyan-12" />
        </Flex>
      );
    case 'improvement':
      return (
        <Flex justify="center" align="center" className={Styles.ReleasesPopUpSparkles} data-type="improvement">
          <TbTrendingUp fontSize="2rem" color="var(--cyan-12" />
        </Flex>
      );
    case 'bug':
      return (
        <Flex justify="center" align="center" className={Styles.ReleasesPopUpSparkles} data-type="bug">
          <TbBug fontSize="2rem" color="var(--cyan-12" />
        </Flex>
      );
    default:
      return (
        <Flex justify="center" align="center" className={Styles.ReleasesPopUpSparkles} data-type="feature">
          <TbSparkles fontSize="2rem" color="var(--cyan-12" />
        </Flex>
      );
  }
}
